import { render } from "./TestReadingContext.vue?vue&type=template&id=06f49cc6&scoped=true"
import script from "./TestReadingContext.vue?vue&type=script&lang=js"
export * from "./TestReadingContext.vue?vue&type=script&lang=js"

import "./TestReadingContext.vue?vue&type=style&index=0&id=06f49cc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f49cc6"]])

export default __exports__